export default __webpack_public_path__ + "static/media/mypaymentdashboard.92b7d2db.svg";